<template>
    <div
        v-if="isShow"
        class="hotel-available-label d-flex align-center"
        :class="{available: room.available, requiest: !room.available}"
    >
        <v-icon v-if="room.available" :title="$t('available')" size="small" start class="text-success">
            mdi-checkbox-marked-circle
        </v-icon>
        <v-icon v-else :title="$t('on_request')" size="small" start class="text-warning">mdi-alert-circle</v-icon>
        <span
            v-if="room.availableRooms && room.availableRooms === 1"
            class="text-warning"
            v-text="$t('available_one_room')"
        />
        <span
            v-else-if="room.availableRooms && room.availableRooms < 5"
            class="text-warning"
            v-text="$t('available_rooms', room.availableRooms)"
        />
        <span v-else-if="room.availableRooms" class="text-success" v-text="$t('enough_available_rooms')" />
        <span v-else-if="!room.available" class="text-warning" v-text="$t('on_request')" />
        <span v-else class="text-success" v-text="$t('available')" />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class HotelAvailableLabel extends Vue {
        @Prop({required: true}) room

        get isShow() {
            return true
        }
    }

    export default HotelAvailableLabel
</script>
